import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Button from 'fe-design-base/molecules/Button';

import { approveClaimRequest } from 'features/notifications/api';
import { useRequestAction } from 'features/notifications/hooks/useRequestAction';

import { dateStringToSeconds, prettyDayAtTimeLowercase } from 'util/dateTime';
import { toI18n } from 'util/i18n';

interface ClaimUserCardProps {
  claim: {
    id: string;
    user_name: string;
    created_at: string;
    totals: {
      scheduled_costs: number;
    };
  };
}

const ClaimUserCard = ({ claim }: ClaimUserCardProps) => {
  const { user_name: name, created_at, totals, id } = claim;
  const { scheduled_costs } = totals;
  const { isLoading: isApprovingClaim, handleAction: handleApproveClaim } =
    useRequestAction({
      apiFunction: approveClaimRequest,
      itemId: id,
      successMessage: 'requests_feed.open_shift.details.approved_success',
      initiatedFrom: 'open_shift_card',
      buttonText: toI18n('requests_feed.actions.approve'),
    });
  return (
    <Box p={16} bgcolor="mono0" bradiusm gap={8} column>
      <Text variant="bodyBoldTight">{name}</Text>
      <Box row alignItemsCenter gap={4}>
        <Text
          variant="captionBold"
          color="mono700"
          i18n="requests_feed.open_shift.details.accepted"
        />

        <Text variant="captions" color="mono700">
          {prettyDayAtTimeLowercase(dateStringToSeconds(created_at) * 1000)}
        </Text>
      </Box>
      <Box row alignItemsCenter gap={4}>
        <Text
          variant="captionBold"
          color="mono700"
          i18n="requests_feed.open_shift.details.estimated_pay"
        />
        <Text variant="captions" color="mono700">
          ${scheduled_costs}
        </Text>
      </Box>
      <Button
        fullWidth
        onClick={handleApproveClaim}
        isLoading={isApprovingClaim}
        disabled={isApprovingClaim}
      >
        {toI18n('requests_feed.actions.approve')}
      </Button>
    </Box>
  );
};

export default ClaimUserCard;
